import React, { useState, useEffect } from "react";
import { opcionesAPI, type MetodoPago } from "@/lib/api";
import { toast } from "sonner";
import { ListNewLoading, ListToolbar } from "@/components/ListNewButton";

interface Props {
  onEdit?: (item: MetodoPago) => void;
  onNew?: () => void;
}

export function MetodosPagoListado({ onEdit, onNew }: Props) {
  const [searchQuery, setSearchQuery] = useState("");
  const [metodosPago, setMetodosPago] = useState<MetodoPago[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await opcionesAPI.listMetodosPago();
        setMetodosPago(data);
      } catch (error) {
        console.error("Error loading metodos pago:", error);
        toast.error("Error al cargar métodos de pago");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const filteredMetodos = metodosPago.filter(m =>
    !searchQuery ||
    m.codigo?.toLowerCase().includes(searchQuery.toLowerCase()) ||
    m.tipo?.toLowerCase().includes(searchQuery.toLowerCase())
  );

  if (loading) {
    return <ListNewLoading onNew={onNew} message="Cargando métodos de pago..." />;
  }

  return (
    <div className="space-y-4 mt-4">
      <ListToolbar onNew={onNew}>
        <label className="block text-sm font-medium mb-1">Buscar</label>
        <input
          type="text"
          placeholder="Buscar por código o tipo..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className="w-full px-4 py-2 border border-input bg-input rounded-lg focus:outline-none focus:ring-2 focus:ring-ring text-sm"
        />
      </ListToolbar>

      {filteredMetodos.length === 0 ? (
        <div className="p-8 text-center text-muted-foreground">
          No se encontraron métodos de pago
        </div>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-muted">
              <tr>
                <th className="px-4 py-2 text-left">Código</th>
                <th className="px-4 py-2 text-left">Tipo</th>
                <th className="px-4 py-2 text-right">Interés (%)</th>
                <th className="px-4 py-2 text-right">Cuotas Máx</th>
              </tr>
            </thead>
            <tbody>
              {filteredMetodos.map((metodo) => (
                <tr
                  key={metodo.codigo}
                  className="border-b hover:bg-muted/50 cursor-pointer"
                  onClick={() => onEdit?.(metodo)}
                >
                  <td className="px-4 py-2">{metodo.codigo}</td>
                  <td className="px-4 py-2">{metodo.tipo}</td>
                  <td className="px-4 py-2 text-right">{metodo.interes}%</td>
                  <td className="px-4 py-2 text-right">{metodo.cuotasMax || 1}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}